// extracted by mini-css-extract-plugin
export default {"errorPage":"NotFound_errorPage__sgUnw","error_container":"NotFound_error_container__+R0fe","zoom_area":"NotFound_zoom_area__zNnH5","link_container":"NotFound_link_container__YyHnY"};